import React, { Component } from "react";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import _ from "lodash";

import { setEnableMobileMenu } from "reducers/ThemeOptions";

import {
	MainNav,
	JobMachaMenu,
	ServiceMachaMenu,
	MyWheelsMenu,
} from "./dataMainNav";

class VerticalNavWrapper extends Component {
	state = {
		readMenu: [...MyWheelsMenu, ...MainNav],
	};

	componentDidMount = () => {
		// myWheels
		// jobmatcha
		// servicematcha
		switch (this.props.data.ProfileReducer.profile.platform) {
			case "jobmacha":
				return this.setState({
					readMenu: [...JobMachaMenu, ...MainNav],
				});
			case "servicemacha":
				return this.setState({
					readMenu: [...ServiceMachaMenu, ...MainNav],
				});
			case "myWheels":
				return this.setState({
					readMenu: [...MyWheelsMenu, ...MainNav],
				});

			default:
				break;
		}
	};

	render = () => {
		return (
			<>
				<br />
				<MetisMenu
					content={this.state.readMenu}
					onSelected={() =>
						this.props.setEnableMobileMenu(!this.props.enableMobileMenu)
					}
					activeLinkFromLocation
					className="vertical-nav-menu"
					iconNamePrefix=""
					classNameStateIcon="pe-7s-angle-down"
				/>
			</>
		);
	};
}

const mapStateToProps = (state) => ({
	data: state,
	enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

export default connect(mapStateToProps, {
	setEnableMobileMenu,
})(VerticalNavWrapper);
